var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('div',{staticClass:"container pt-3 pb-3"},[_c('router-view')],1),_c('notifications',{attrs:{"group":"WtcApp","position":"top center"}}),_c('loading-spinner'),_c('SessionTimeout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }